
export const ConvertMiladiToJalali = (jalaliData: any) => {
    return jalaliData ? new Date(jalaliData).toLocaleDateString('fa-Ir') : ''
}

export const AccountStatus = (status: string) => {
    if (status == 'daily_loss_limit') {
        return {
            'title': 'حد ضرر روزانه',
            'color': '#fff',
        }
    }
    else if (status == 'total_loss_limit') {
        return {
            'title': 'حد ضرر کلی',
            'color': '#fff',
        }

    }
    else if (status == 'success_in_challenge') {
        return {
            'title': 'موفق شدن در چالش',
            'color': '#fff',
        }
    }
    else if (status == 'changed_account') {
        return {
            'title': 'اکانت تعویض شده',
            'color': '#fff',
        }
    }
    else if (status == 'date_expired_challenge') {
        return {
            'title': 'زمان پایان چاش',
            'color': '#fff',
        }
    }
    else if (status == null) {
        return {
            'title': 'درحال چالش',
            'color': '#fff',
        }
    }
}


export const AccountLevel = (level: string) => {

    if (level == '1') {
        return 'مرحله اول'
    }
    else if (level == '2') {
        return 'مرحله دوم'
    }
    else if (level == '3') {
        return 'حساب ریل'
    }
}




export let AllFields = [
    {
        'title': 'بالانس اکانت',
        'en_title': 'balance',
        'isActive': true,
        'category': 1,
    },
    {
        'title': 'هدف سود ',
        'en_title': 'account_target',
        'isActive': true,
        'category': 1,
    },
    {
        'title': 'زمان خرید چالش',
        'en_title': 'created_at',
        'isActive': true,
        'category': 1,
    },
    {
        'title': ' زمان پایان چالش',
        'en_title': 'licence_expired_at',
        'isActive': true,
        'category': 1,
    },
    {
        'title': ' درصد سود / زیان کلی',
        'en_title': 'Total_profit_and_loss_percentage',
        'isActive': true,
        'category': 1,
    },
    {
        'title': ' درصد سود / زیان روزانه ',
        'en_title': 'Today_profit_and_loss_percentage_based_on_balance',
        'isActive': true,
        'category': 1,
    },
    {
        'title': 'تعداد معاملات',
        'en_title': 'trades',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'معاملات موفق',
        'en_title': 'wonTrades',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'معاملات ناموفق',
        'en_title': 'lostTrades',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'بهترین معامله ',
        'en_title': 'bestTrade',
        'isActive': true,
        'category': 2,
    },
    {
        'title': ' بدترین معامله',
        'en_title': 'worstTrade',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'میانگین سود',
        'en_title': 'averageWin',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'میانگین ضرر',
        'en_title': 'averageLoss',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'میانگین سود پیپ',
        'en_title': 'averageWinPips',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'میانگین ضرر پیپ',
        'en_title': 'averageLossPips',
        'isActive': true,
        'category': 2,
    },
    {
        'title': 'برآیند پیپ معامله شده',
        'en_title': 'pips',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'حجم معامله شده (لات)',
        'en_title': 'lots',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'میانگین زمان معاملات (دقیقه)',
        'en_title': 'averageTradesTime',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'کمترین زمان معاملات (دقیقه)',
        'en_title': 'minimumTradesTime',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'بیشترین زمان معامله (دقیقه)',
        'en_title': 'maximumTradesTime',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'بیشترین نماد معامله شده',
        'en_title': 'maxSymbol',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'کمترین نماد معامله شده',
        'en_title': 'minSymbol',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'بازدهی مورد انتظار',
        'en_title': 'test5',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'بازدهی مورد انتظار بر اساس پیپ',
        'en_title': 'test6',
        'isActive': true,
        'category': 3,
    },
    {
        'title': 'Profit Factor',
        'en_title': 'profit_factor',
        'isActive': true,
        'category': 4,
    },
    {
        'title': 'Sharpe Ratio',
        'en_title': 'sharpe_ratio',
        'isActive': true,
        'category': 4,
    },
    {
        'title': 'Sartino Ratio',
        'en_title': 'sartino_ratio',
        'isActive': true,
        'category': 4,
    },
    {
        'title': 'z Score',
        'en_title': 'z_score',
        'isActive': true,
        'category': 4,
    },
    {
        'title': 'نماد',
        'en_title': 'order_Symbol',
        'isActive': true,
        'category': 5,
    },
    {
        'title': 'نوع معامله',
        'en_title': 'order_type',
        'isActive': true,
        'category': 5,
    },
    {
        'title': 'حجم',
        'en_title': 'order_lots',
        'isActive': true,
        'category': 5,
    },
    {
        'title': 'پیپ',
        'en_title': 'pip',
        'isActive': true,
        'category': 5,
    },
    {
        'title': ' سود/ ضرر ',
        'en_title': 'order_profit',
        'isActive': true,
        'category': 5,
    },
    {
        'title': ' زمان باز شدن پوزیشن',
        'en_title': 'order_open_time',
        'isActive': true,
        'category': 5,
    },
    {
        'title': ' زمان بسته شدن پوزیشن',
        'en_title': 'order_close_time',
        'isActive': true,
        'category': 5,
    },
]



export const methodHandelCheckUserFields = (
    userId: string,
    setCurrentUserFields: (obj: any) => void,
) => {
    if (localStorage.getItem("userFields") == null && userId != "") {
        let data: any = {}
        data[userId] = AllFields
        localStorage.setItem('userFields', JSON.stringify(data))
        localStorage.setItem('userId', JSON.stringify(userId))
        setCurrentUserFields(AllFields)
    }
    else if (userId != "") {
        let localData = JSON.parse(String(localStorage.getItem("userFields")))
        if (localData[userId]) {
            setCurrentUserFields(localData[userId])
        }
        else {
            setCurrentUserFields(AllFields)
            localData[userId] = AllFields;
            localStorage.setItem('userFields', JSON.stringify(localData))
            localStorage.setItem('userId', JSON.stringify(userId))
        }
    }
}


export const methodHandelChangeFields = (
    userId: string,
    item: any,
    setCurrentUserFields: (obj: any) => void,
) => {
    let localData = JSON.parse(String(localStorage.getItem("userFields")));
    let user_fields = localData[userId];
    for (let i of user_fields) {
        if (i.en_title == item.en_title) {
            i.isActive = !i.isActive;
        }
    }
    setCurrentUserFields(user_fields)
    localData[userId] = user_fields;
    localStorage.setItem('userFields', JSON.stringify(localData))
}

export const methodCheckIsActiveFields = (
    en_title: string,
) => {
    if (localStorage.getItem("userFields") != null) {
        let userId: any = String(localStorage.getItem('userId'));
        let localData = JSON.parse(String(localStorage.getItem("userFields")));
        for (const [key, value] of Object.entries(localData)) {
            if (`"${key}"` == userId) {
                //@ts-ignore
                for (let i of value) {
                    if (i.en_title == en_title) {
                        return i.isActive
                    }
                }
            }
        }
    }
    else {
        return true
    }
}




export const methodChangeTableCol = (
    col: any,
    setCol: (obj: any) => void,
    currentUserFields: any,
) => {
    if (col && currentUserFields) {
        let col_list: any = [...col]
        for (let i in col_list) {
            for (let j of currentUserFields)
                if (col[i].en_title == j.en_title) {
                    if (j.isActive == true) {
                        col_list[i].isActive = true;
                    }
                    else if (j.isActive == false) {
                        col_list[i].isActive = false;
                    }
                }
        }
        setCol(col_list)
    }
}